// @flow

import React from 'react';
import bemify, { toModifiers } from 'bemify-js';
import { isEmpty, noop } from 'lodash';

import { Icon } from '@zapier/common-components';

import Button from 'web-ssr/app/common/components/Button';
import TextInput from 'web-ssr/app/common/components/TextInput';
import 'web-ssr/app/common/components/SearchBox.scss';

import type { Node } from 'react';

import type { KindType } from 'web-ssr/app/common/types';

const bem = bemify('search-box');

type Props = {
  className?: string,
  disabled?: boolean,
  showClearButton?: boolean,
  onBlur?: () => void,
  onChange?: (value: string) => void,
  onClear?: () => void,
  onFocus?: () => void,
  placeholder?: string,
  renderIcon?: ({ className: string }) => Node,
  value: string,
  kind?: KindType,
  inputRef?: any,
};

const SearchBox = (props: Props) => {
  const {
    className,
    disabled,
    showClearButton = false,
    onBlur,
    onChange = noop,
    onClear = noop,
    onFocus,
    renderIcon,
    value,
    kind,
    inputRef,
  } = props;

  const clearSearchNode =
    !showClearButton || disabled || isEmpty(value) ? null : (
      <Button
        ariaLabel="Clear search text"
        className={bem('__after-icon', toModifiers(kind))}
        kind="clear"
        onClick={() => {
          onChange('');
          onClear();
        }}
      >
        <Icon
          className={bem('__clear-icon', toModifiers(kind))}
          name="delete"
          size={14}
        />
      </Button>
    );

  return (
    <div className={bem(className, toModifiers(kind))}>
      {renderIcon && (
        <div className={bem('__before-icon', toModifiers(kind))}>
          {renderIcon({ className: bem('__icon', toModifiers(kind)) })}
        </div>
      )}
      <TextInput
        {...props}
        autoComplete="off"
        className={bem('__input', toModifiers(kind))}
        disabled={disabled}
        name="search"
        onBlur={onBlur}
        onFocus={onFocus}
        ref={inputRef}
        type="text"
      />
      {clearSearchNode}
    </div>
  );
};

export default SearchBox;
